export class LoginInput {
    public username: string;
    public password: string;

    constructor() {
        this.username = '';
        this.password = '';
    }
}